module.exports = __webpack_public_path__ + "static/media/QRCode.466353c2.jpeg";